export * from './lib/about-euromonitor.module';
export * from './lib/about-euromonitor.component';
